import axios from "axios";

const url = process.env.REACT_APP_BACKEND_URL;

export const UpdatePassword = async (passwords, userID) => {
  return await axios.post(url + "updatePassword", { ...passwords, userID });
};
